import SiteLayout from "@/components/site/SiteLayout";
import Page from "@/pages/Page";
import NotFound from "@/pages/NotFound";
import { getBootstrap } from "@/lib/bootstrap";

const App = () => {
  const { page } = getBootstrap();

  return (
    <SiteLayout>
      {page.is_404 ? <NotFound /> : <Page />}
    </SiteLayout>
  );
};

export default App;
